import React from "react";
import { useForm } from 'react-hook-form';
import ContactService from "../../services/contactService";
import toaster from "../../helpers/toaster";

const Footer = () => {
    const { register, handleSubmit, formState: { errors }, reset } = useForm();
    const contactService = new ContactService();

    const onSubmit = async (data) => {
        const result = await contactService.saveContact(data);
        if (result.success) {
            new toaster().successMessage(result.message);
            reset();
        } else {
            new toaster().errorMessage(result.message);
        }
    };

    return (
    
    <>
    <div id="contactus" className="herobtmstrip" style={{ backgroundImage: "url(/images/herobtmstrips-btm.png)"}} ></div>
    <div className='footersec'>
        <footer>
            <div className='container'>
                <div className='row justify-content-center'>
                 <div className='col-md-6 text-center'>
                    <h2>Contact Us</h2>
                        <h6>We would love to hear from you. Provide your information below and reach out with any questions</h6>
                  </div>
                    <div className='col-md-7'>
                       <form onSubmit={handleSubmit(onSubmit)}>
                        <div className='row'>
                            <div className='col mb-3'>
                            <input type='text' className='form-control' placeholder='Full Name*' {...register("fullName", { required: "Full Name is required" })} />
                            {errors.fullName && <p className="errorMessage">{errors.fullName.message}</p>}
                            </div>
                            <div className='col mb-3'>
                            <input type='text' className='form-control' placeholder='Email*' {...register("email", { required: "Email is required", pattern: { value: /^\S+@\S+$/i, message: "Invalid email address" } })} />
                            {errors.email && <p className="errorMessage">{errors.email.message}</p>}
                            </div>
                            <div className='col-12 mb-4'>
                            <textarea className='form-control' rows='5' placeholder='Message' {...register("message", { required: "Message is required" })}></textarea>
                            {errors.message && <p className="errorMessage">{errors.message.message}</p>}
                            </div>
                            <div className='col-12 text-center'>
                                <input type='submit' className='btn btn-primary' value='Submit'></input>
                            </div>
                        </div>
                        </form>
                    </div>
                </div>
            </div>
        </footer>
    
    </div> 
    </>
    

    )
  };
  
  export default Footer;
  